import React from 'react';
import Yup from 'yup';
import moment from 'moment';
import createForm, { TextField, DateField, ResourceField } from '../../shared/forms';
import API from '../../shared/forms/API';
import Resources from '../../shared/forms/Resources';
import { employeeDateFormat } from '../../employees/EmployeesConstants';

const definitions = {
  name: {
    title: 'Naam',
    placeholder: 'bijv. CRM Integratie'
  },
  expiresAt: {
    title: 'Verloopt op'
  },
  userId: {
    title: 'Gebruiker',
    resource: Resources.user
  }
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Naam is verplicht'),
  userId: Yup.string().required('Gebruiker is verplicht'),
  expiresAt: Yup.string()
    .required('Verloopdatum is verplicht')
    .test('future-date', 'Datum moet in de toekomst liggen', (value) => {
      if (!value) return false;
      const date = moment(value, employeeDateFormat);
      return date.isValid() && date.isAfter(moment());
    })
});

export const apiKeyInitialValues = (currentUser) => ({
  name: '',
  userId: (currentUser && currentUser.uuid) || '',
  expiresAt: moment().add(1, 'year').format(employeeDateFormat)
});

export const apiKeyRequest = (values) => ({
  name: values.name,
  userId: values.userId,
  expiresAt: moment(values.expiresAt, employeeDateFormat).format('YYYY-MM-DD')
});

export const userOptionLabel = (user) => {
  return Resources.user.value(user);
};

const ApiKeyCreateFormView = (props) => {
  const { isSubmitting, status, handleSubmit, touched, isValid, onCancel } = props;

  return (
    <form onSubmit={handleSubmit}>
      {status && (
        <div className={`alert alert-${status.type}`}>{status.text}</div>
      )}

      <TextField
        name="name"
        definitions={definitions}
        props={props}
        autoFocus
      />

      <ResourceField
        {...props}
        name="userId"
        definitions={definitions}
        update={{ userId: props.currentUser }}
        helpText="Deze API key gebruikt dezelfde rechten als de geselecteerde gebruiker."
      />

      <DateField
        name="expiresAt"
        definitions={definitions}
        {...props}
      />

      <div>
        <button
          type="submit"
          className={`btn ${Object.keys(touched).length > 0 && isValid ? 'btn-success' : 'btn-primary'}`}
          disabled={!Object.keys(touched).length || isSubmitting}
        >
          {isSubmitting && <i className="fa fa-spinner fa-spin mr-1" />}
          Aanmaken
        </button>
        <button
          type="button"
          className="btn btn-secondary float-right"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Annuleren
        </button>
      </div>
    </form>
  );
};

export default createForm({
  resourceName: 'api_key',
  submitPath: () => 'admin/api-keys',
  mapPropsToValues: (props) => apiKeyInitialValues(props.currentUser),
  validationSchema,
  customSubmitHandler: (values, bag) => {
    const { onSuccess } = bag.props;

    new API()
      .submit('admin/api-keys', 'POST', apiKeyRequest(values))
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            onSuccess(data.key);
          });
        } else {
          if (response.status === 400) {
            response.json().then((data) => {
              if (data.errors) {
                let errors = {};
                for (var key in data.errors.children) {
                  const fieldErrors = data.errors.children[key].errors;
                  if (fieldErrors) {
                    errors[key] = fieldErrors[0];
                  }
                }
                bag.setErrors(errors);
              }
              bag.setStatus({ type: 'warning', text: data.error || data.message || 'Er is een fout opgetreden.' });
            });
          } else {
            bag.setStatus({ type: 'danger', text: 'Er is een onverwachte fout opgetreden.' });
          }
        }
        bag.setSubmitting(false);
      })
      .catch((error) => {
        console.error(error);
        bag.setStatus({ type: 'danger', text: 'Er is een fout opgetreden.' });
        bag.setSubmitting(false);
      });
  },
  form: ApiKeyCreateFormView
});
